import { QuestionCard } from "newui/features/Rfx/Creation/components/ReturnableSchedule/QuestionCard";
import React, { useMemo } from "react";
import { QuoteContent } from "./QuoteContent";

const QuoteCard = ({
	cardTitle,
	initialDataItem,
	handleChangeInput,
	cardDescription,
	value,
	dragHandle,
	tableVariable,
	index,
	quotesTable,
	setQuotesTable,
	isPreview,
	disable,
	type = "template",
}) => {
	const isQuoteDeletable = useMemo(() => {
		const nonRemovedQuotes = quotesTable?.filter((quote) => !quote.isRemove);
		const isDeletable = nonRemovedQuotes?.length > 1;
		return isDeletable;
	}, [quotesTable]);

	const deleteQuotesHandler = () => {
		let newQuotes = [...quotesTable];
		if (newQuotes[index]?.id) {
			// set table to be removed
			newQuotes[index].isRemove = 1;

			// set table items to be removed
			newQuotes[index].items = newQuotes[index].items
				?.filter((item) => item.id !== null)
				.map((item) => {
					return { ...item, isRemove: 1 };
				});
		} else {
			newQuotes.splice(index, 1);
		}
		setQuotesTable(newQuotes);
	};

	const copyQuotesHandler = () => {
		let newQuotes = [...quotesTable];
		newQuotes.push({
			...newQuotes[index],
			id: null,
			isRemove: 0,
			sort_order: newQuotes.length + 1,
		});
		setQuotesTable(newQuotes);
	};

	return (
		<div className="my-6 w-full">
			<QuestionCard
				dragHandle={dragHandle}
				divider={false}
				isQuote
				sectionIndex={index}
				isDeletable={isQuoteDeletable}
				deleteQuotesHandler={deleteQuotesHandler}
				copyQuotesHandler={copyQuotesHandler}
				isPreview={isPreview}
			>
				<QuoteContent
					cardTitle={cardTitle}
					initialDataItem={initialDataItem}
					handleChangeInput={handleChangeInput}
					cardDescription={cardDescription}
					value={value}
					tableVariable={tableVariable}
					index={index}
					isPreview={isPreview}
					type={type}
					disable={disable}
				/>
			</QuestionCard>
		</div>
	);
};

export default QuoteCard;
